import CardCarouselBlock from './CardCarouselBlock';

export default CardCarouselBlock;